import type { Instance } from "@gadgetinc/mobx-quick-tree";
import { RichString } from "../../RichString";
import { WorkspacePageType } from "../../WorkspacePageType";
import { createProblemFinder } from "../createProblemFinder";
import type { ShopifyBaseAdminAppConfig } from "../../connections/shopify/ShopifyBaseAdminAppConfig";

/*
 * NOTE: These problems are also mirrored in
 * ShopifyConnectionFormProblems, for local form state, any updates
 * here should also be applied there
 */
export const ShopifyAdminAppConfigProblems = createProblemFinder<Instance<ReturnType<typeof ShopifyBaseAdminAppConfig>>>(
  {
    shopDomain: {
      host: {
        message: (_value, _attribute, _options, node) =>
          `Shopify app configuration with api key ${RichString.text(node.apiKey)} has an invalid shop domain`,
        inContextMessage: "Shop domain must be a valid domain",
      },
    },
    accessToken: {
      presence: {
        allowEmpty: false,
        message: (_value, _attribute, _options, node) =>
          `Shopify app configuration with api key ${RichString.text(node.apiKey)} is missing an access token`,
        inContextMessage: "Access token can't be blank",
      },
    },
  },
  {
    name: "Shopify Manual App Configuration",
    tabType: WorkspacePageType.PluginsIndex,
    fullMessages: false,
  }
);
